import React, { useState, useEffect} from "react";
import {useAuth} from "../../AuthContext";
import "./PaymentWidget.css";
import { ReactComponent as Refresh } from '../../icons/refresh.svg';

export function PaymentWidget() {
    const [amount, setAmount] = useState('');
    const [paymentInfo, setPaymentInfo] = useState(null);
    const [iPaid, setIPaid] = useState(false);
    const [reloading, setReloading] = useState(false);

    const { user, fetchWithAuth, reloadUser } = useAuth();

    const handleCreatePayment = async () => {
        setPaymentInfo(false);
        setIPaid(false);
        const res = await fetchWithAuth('/api/create-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: parseFloat(amount) })
        });

        const data = await res.json();
        setPaymentInfo(data);
    };

    const handleIPaid = () => {
        setIPaid(true);

        // ⏱ Автоматические проверки через 3, 5 и 10 минут
        [60000, 180000, 300000, 600000].forEach(delay => {
            setTimeout(() => {
                reloadUser();
            }, delay);
        });
    };
    const handleReload = async () => {
        if (reloading) return;
        setReloading(true);
        await Promise.all([
            reloadUser(),
            new Promise((res) => setTimeout(res, 500)) // гарантированная задержка
        ]);
        setReloading(false);
    };

    useEffect(() => {
        const listener = () => handleReload();
        window.addEventListener('force-balance-reload', listener);
        return () => window.removeEventListener('force-balance-reload', listener);
    }, []);
    return (
        <div className="paymentWidgetContainer">
            <div className="paymentWidgetBalanceInfoContainer">
                <span className="paymentWidgetBalanceInfo">Balance:
                    <div className="paymentWidgetBalanceInfoNumber">
                        <div>{!reloading ? user?.balance : <span className="shimmer" style={{ width: 500, height: 20 }} />} USDT</div>
                        <div
                            onClick={handleReload}
                            className={reloading ? 'paymentWidgetReloadBalanceSpin' : 'paymentWidgetReloadBalance'}
                        >
                            <Refresh />
                        </div>
                    </div>
                </span>
            </div>
            <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Amount (USDT)"
                className="paymentWidgetAddNumber"
            />
            <button
                onClick={handleCreatePayment}
                className="addBalanceButton"
            >
                <div className="addBalanceButtonText">Top up</div>
            </button>
            {paymentInfo && (
                <div style={{width: '100%'}}>
                    {iPaid ? <ul className="paymentWidgetPaymentInfo">
                        <li>Thank you for your payment!</li>
                        <li>We will automatically verify the receipt of funds and update your balance.</li>
                    </ul> : <>
                        <ul className="paymentWidgetPaymentInfo">
                            <li>Payment ID: <span className="paymentWidgetBalanceInfoNumber">{paymentInfo?.paymentId}</span></li>
                            <li>Send <span className="paymentWidgetBalanceInfoNumber">{paymentInfo?.expectedAmount}</span> USDT
                                (TRC-20) to the address:
                            </li>
                            <li><span className="paymentWidgetBalanceInfoNumber">{paymentInfo?.address}</span></li>
                            <li>Send the EXACT amount specified above within 1 hour.</li>
                            <li>This is important for faster verification of your payment.</li>
                            <li>After the transfer and confirmation, the payment will be reflected in your balance.</li>
                            <li>This usually takes less than three minutes.</li>
                        </ul>
                        <button
                            onClick={handleIPaid}
                            className="paymentWidgetIPaidButton"
                        >
                            <div className="paymentWidgetIPaidButtonText">I have paid</div>
                        </button>
                    </>}
                </div>
            )}
        </div>
    );
}